/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new user.
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    role: CreateUserRequestRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUserRequest
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    firebaseUid: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    firebaseProvider?: CreateUserRequestFirebaseProviderEnum;
}


/**
 * @export
 */
export const CreateUserRequestRoleEnum = {
    Owner: 'owner',
    Admin: 'admin',
    Member: 'member',
    Viewer: 'viewer'
} as const;
export type CreateUserRequestRoleEnum = typeof CreateUserRequestRoleEnum[keyof typeof CreateUserRequestRoleEnum];

/**
 * @export
 */
export const CreateUserRequestFirebaseProviderEnum = {
    Password: 'password',
    GoogleCom: 'google.com',
    MicrosoftCom: 'microsoft.com'
} as const;
export type CreateUserRequestFirebaseProviderEnum = typeof CreateUserRequestFirebaseProviderEnum[keyof typeof CreateUserRequestFirebaseProviderEnum];


/**
 * Check if a given object implements the CreateUserRequest interface.
 */
export function instanceOfCreateUserRequest(value: object): value is CreateUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('firebaseUid' in value) || value['firebaseUid'] === undefined) return false;
    return true;
}

export function CreateUserRequestFromJSON(json: any): CreateUserRequest {
    return CreateUserRequestFromJSONTyped(json, false);
}

export function CreateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'role': json['role'],
        'companyId': json['companyId'],
        'firebaseUid': json['firebaseUid'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'firebaseProvider': json['firebaseProvider'] == null ? undefined : json['firebaseProvider'],
    };
}

export function CreateUserRequestToJSON(json: any): CreateUserRequest {
    return CreateUserRequestToJSONTyped(json, false);
}

export function CreateUserRequestToJSONTyped(value?: CreateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'role': value['role'],
        'companyId': value['companyId'],
        'firebaseUid': value['firebaseUid'],
        'avatarUrl': value['avatarUrl'],
        'firebaseProvider': value['firebaseProvider'],
    };
}

